<template>
  <div class="qrcode-popup" :style="{left:(left?left + 'px':''), top: (top? top + 'px': '')}">
    <img class="qrcode-thumb"  :src="require('@/assets/img/resources/' + (product_id|utils.product_id_boolean?'code/' + product_id + '_code.jpg':'WechatIMG146.jpeg'))"/>
    <div class="f14 gray-1 text-center">请使用微信扫一扫下单</div>
  </div>
</template>

<script>
  import utils from '@/controller/utils'
  export default {
    name: "weChatCode",
    props:['left', 'top', 'product_id'],
    data () {
      return {
        utils: utils,
      }
    },
    mounted () {
    }
  }
</script>

<style lang="less" scoped>
  .qrcode-thumb {
    width: 100%;
    height: 100%;
  }
  .text-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/weChatCode.vue